if (!customElements.get('estoria-offer-progress')) {
  let latestCart;
  let lastMessage;
  const protectionProductIds = new Set(['8148262191182', '8141791101006']);
  const protectionVariantIds = new Set(['44569297682510', '44551592509518']);
  customElements.define('estoria-offer-progress', class extends HTMLElement {
    connectedCallback() {
      this.steps = this.querySelectorAll('[data-tier]');
      this.status = this.querySelector('[data-offer-progress-status]');
      if (latestCart) this.update(latestCart);
      if (lastMessage === undefined) lastMessage = this.status.textContent;
    }

    update(cart) {
      const count = cart.items.reduce((total, item) => {
        // Protection is an add-on, not qualifying merchandise. Use Shopify IDs,
        // never editable line properties, to keep the rail aligned with the offer.
        if (protectionProductIds.has(String(item.product_id)) ||
            protectionVariantIds.has(String(item.variant_id))) return total;
        // Included components remain nested under their native parent.
        return Number.isInteger(item.quantity) && item.quantity > 0
          ? total + item.quantity
          : total;
      }, 0);
      const tier = Math.min(count, 3);
      this.dataset.count = String(count);
      this.steps.forEach(step => {
        const number = Number(step.dataset.tier);
        step.classList.toggle('is-reached', number <= tier);
        step.classList.toggle('is-linked', number < tier);
        if (number === tier) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      const message = this.dataset[['empty', 'one', 'two', 'three'][tier]];
      if (this.status.textContent !== message) this.status.textContent = message;
    }
  });

  let revision = 0;
  const isFullCart = cart => Array.isArray(cart?.items) && Number.isInteger(cart.item_count);
  const syncCart = async (event = {}) => {
    const current = ++revision;
    try {
      let cart = event.cartData;
      // Add responses contain only the added lines, not the complete cart.
      if (!isFullCart(cart)) {
        // A confirmed add invalidates the pre-add cache before fresh sections mount.
        latestCart = undefined;
        const response = await fetch(`${window.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) return;
        cart = await response.json();
      }
      if (current !== revision || !isFullCart(cart)) return;
      // Native section responses can arrive after a newer quantity update.
      latestCart = cart;
      const elements = document.querySelectorAll('estoria-offer-progress');
      elements.forEach(element => element.update(cart));
      const message = elements[0]?.status.textContent;
      const announcement = document.querySelector('[data-offer-announcement]');
      if (announcement && message && message !== lastMessage) {
        announcement.textContent = message;
        lastMessage = message;
      }
    } catch {
      // Retain the last verified state without interrupting the native cart.
    }
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, syncCart);
  window.addEventListener('pageshow', event => {
    if (event.persisted) return syncCart();
  });
}

